export const PENDING = 'Pending';
export const IN_PROGRESS = 'In Progress';
export const COMPLETE = 'Complete';
export const VOID = 'Void';
export const PAID = 'Paid';
export const UNPAID = 'Awaiting Payment';
